import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import { InviteLinks, Userspaces } from '@busy-human/opt-library'
import { DataInstance } from '@busy-human/gearbox';
import VQrCode from '@/components/QrCode.vue'

type Props = {
    user: Userspaces.Model
    selectedLink: DataInstance<InviteLinks.Model>,
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'qr-overlay',
  props: {
    user: null,
    selectedLink: null
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    user: Userspaces.Model
    selectedLink: DataInstance<InviteLinks.Model>,
}





const inviteLink = computed(() => {
    if(props.selectedLink) {
        return `${window.location.protocol}//${window.location.host}/#/invite/${props.selectedLink.link}`
    } else return undefined;
})


let userInitials = ref(((props.user?.name?.firstName?.[0] || '')+' '+(props.user?.name?.lastName?.[0] || '')).toUpperCase())

const __returned__ = { props, emit, inviteLink, userInitials, ref, onMounted, computed, InviteLinks, Userspaces, DataInstance, VQrCode }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})